import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/aes/shipment'
import pathMap from 'src/paths/pathMap'

class AesShipmentRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.AES_SHIPMENT_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.AES_SHIPMENT_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.AES_SHIPMENT_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.AES_SHIPMENT_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AesShipmentRoute
